"use strict";

module.exports = function () {
  var columns = Object.keys(this.opts.listColumns);
  var res = {};
  columns.forEach(function (column) {
    res[column] = {};
    this.opts.listColumns[column].forEach(function (item) {
      res[column][item.id] = item.text;
    });
  }.bind(this));
  return res;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/list-columns-object.js
// module id = 1562
// module chunks = 64